"use client";

import { OfferSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedOfferSection from "../Components/GeneratedOfferSection";

const Offer: FC<OfferSectionProps> = (props) => {
  return <GeneratedOfferSection {...props} />;
};

export default Offer;
